const BANK_ACCOUNT_NUMBER_REGEX = RegExp('^[0-9]{15,16}$');

export const isValidBankAccountNumber = (bankAccountNumber?: string): boolean => {
  if (!bankAccountNumber) {
    return false;
  }

  const isFormatValid = BANK_ACCOUNT_NUMBER_REGEX.test(bankAccountNumber);

  if (!isFormatValid) {
    return false;
  }

  return true;
};
